module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator bold"
  }, [(_vm.editable) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.doTheMath('subtract')
      }
    }
  }, [_c('span', {
    staticClass: "ico-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "mx-2 my-0",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.object[_vm.field]
    },
    on: {
      "input": _vm.directInput
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "less",
    on: {
      "click": function($event) {
        return _vm.doTheMath('add')
      }
    }
  }, [_c('span', {
    staticClass: "ico-add"
  })])]) : _c('div', {
    staticClass: "mx-2 my-0 fs-large"
  }, [_vm._v(_vm._s(_vm.input))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6ccd5b64", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ccd5b64"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Calculator.vue
// module id = 1700
// module chunks = 0